const fields = {
    IDS: 'ids',
    COHORT_ID: 'cohortId',
};

export default fields;
